import {Grid} from "@mui/material";
import {Item} from "./Item";
import * as React from "react";
import {useEffect, useState} from "react";
import {ErrorOutline} from "@mui/icons-material";
import {stateManager} from "../../../stateManager";
import {dealData} from "../../../pages/deal/deal";
export const criticalErrorsEnums = {
  CHANGE_AFTER_STATEMENT: 'В сделку были внесены изменения после создания заявления. Необходимо заново сформировать заявление.',
}

/**
 * Выводим контейнер с критическими ошибками
 */
export const CriticalErrorsComponent = () => {
  const [dealChangedAfterStatement, setDealChangedAfterStatement] = useState(false);

  useEffect(() => {
    if (dealData.deal.isBlockedForRegistration && dealData.dealXmlStatementsList?.length)
      setDealChangedAfterStatement(true)

    const unsubscribe = stateManager.subscribe((newState) => {
      if(dealData.dealXmlStatementsList?.length)
        setDealChangedAfterStatement(newState.isBlockedForRegistration);
    });

    return unsubscribe;
  }, [])

  if (!dealChangedAfterStatement)
    return;

  return (
    <Grid container spacing={1} sx={{mt: 0.2}}>
      <Grid item xs={12}>
        {dealChangedAfterStatement ? <DealHasChangedAfterStatementComponent /> : null}
      </Grid>
    </Grid>
  )
}

export const DealHasChangedAfterStatementComponent = () => <Item sx={{backgroundColor: '#fdd4d4'}}>
  <Grid container spacing={1}>
  <Grid item xs={0.3} sx={{display: "inline-block", pt: '10px', lineHeight: '5px'}}>
    <ErrorOutline sx={{color: '#e82d2d', fontSize: '19px'}}/>
  </Grid>
  <Grid item xs={11.7} sx={{paddingTop: '10px'}}>
    {criticalErrorsEnums.CHANGE_AFTER_STATEMENT}
  </Grid>
  </Grid></Item>